module.exports = __webpack_public_path__ + "img/dentist.b95f0d88.svg";